import { render, staticRenderFns } from "./LocaleChanger.vue?vue&type=template&id=d454b820"
import script from "./LocaleChanger.vue?vue&type=script&lang=js"
export * from "./LocaleChanger.vue?vue&type=script&lang=js"
import style0 from "./LocaleChanger.vue?vue&type=style&index=0&id=d454b820&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports